import { render } from "./Figuur.vue?vue&type=template&id=e2dcbf24&scoped=true"
import script from "./Figuur.vue?vue&type=script&lang=js"
export * from "./Figuur.vue?vue&type=script&lang=js"

import "./Figuur.vue?vue&type=style&index=0&id=e2dcbf24&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-e2dcbf24"

export default script